export default "<app-ask-model></app-ask-model>\r\n<app-timeline-view></app-timeline-view>\r\n<app-ml-timeperiods></app-ml-timeperiods>\r\n";